import { useBookingContext } from '../contexts/BookingContext';
import AppointmentConfirmation from './templates/AppointmentConfirmation';
import CancelAppointment from './templates/CancelAppointment';
import ChangeAppointment from './templates/ChangeAppointment';
import Error from './templates/Error';
import ExistingAppointment from './templates/ExistingAppointment';
import ScheduleAppointment from './templates/ScheduleAppointment';

interface BookingRouterProps {
	getLabel: (key: string) => string;
	onExit?: () => void | undefined;
}

export default function BookingRouter({ getLabel, onExit }: BookingRouterProps) {
	const { appointment } = useBookingContext();

	if (appointment.pendingCancellation) {
		return <CancelAppointment getLabel={getLabel} />;
	}

	if (appointment.submissionError !== null) {
		return <Error getLabel={getLabel} message={appointment.submissionError.message} detail={appointment.submissionError.detail || ''} />;
	}

	if (appointment.data) {
		if (appointment.source === 'stored') {
			return <ExistingAppointment getLabel={getLabel} />;
		}

		return <AppointmentConfirmation getLabel={getLabel} />;
	}

	if (appointment.isEditing) {
		return <ChangeAppointment getLabel={getLabel} />;
	}

	return <ScheduleAppointment getLabel={getLabel} onExit={onExit} />;
}
